// Process Header
// Process Categories
// Process Questions

import { numberToLetters } from "../others";
import {
  getCategoryMarksContent,
  getCommonCategoryHeaderContent,
  getCommonContent,
  getHeaderContent,
  getType16Content,
  getType1Content,
  getType6Content,
} from "./getContent";

export function clearHeaderContent(content) {
  return content.replace(
    /<!-- HEADER_START -->([\s\S]*?)<!-- HEADER_END -->/,
    ""
  );
}

export function processHeaderContent(formData) {
  const header = getHeaderContent(
    formData.schoolName,
    formData.examName,
    formData.className,
    formData.subjectName || "",
    formData.maxMarks,
    formData.duration,
    formData.displayTerms,
    formData.displayHeader,
    formData.termsText,
    formData
  );
  return header;
}

export function processCategories(questions, categories, formData) {
  const content = processCategoriesContent(categories, questions);
  const headerContent = processHeaderContent(formData);

  return headerContent + content;
}

function processCategoriesContent(categories, questions) {
  const content = categories
    .filter((c) => c.type_id !== "header" && c.display === true)
    .sort((a, b) => a.orderId - b.orderId)
    .map((c, i) => {
      const categoryQuestions = questions.filter(
        (q) => q.question_typeid === c.type_id
      );
      const categoryMarks = Number(c.marks || 1) * Number(c.questions || 1);
      const displayMarks = getCategoryMarksContent(
        c.marks,
        c.questions,
        categoryMarks
      );
      const children = processQuestions(categoryQuestions, c.marks);
      return getCommonCategoryHeaderContent(
        numberToLetters(i + 1),
        c.type_title,
        displayMarks,
        children
      );
    })
    .join(" ");
  return content;
}

export function processQuestions(questions, marks) {
  const data = questions.map((question, i) => {
    if (question.question_typeid === 1 || question.question_typeid === 30) {
      return getType1Content(i + 1, question, marks || 0);
    }
    if (question.question_typeid === 6) {
      return getType6Content(i + 1, question, marks || 0);
    }
    if (
      question.question_typeid === 3 ||
      question.question_typeid === 4 ||
      question.question_typeid === 5 ||
      question.question_typeid === 8 ||
      question.question_typeid === 9 ||
      question.question_typeid === 10 ||
      question.question_typeid === 11 ||
      question.question_typeid === 15
    ) {
      return getCommonContent(i + 1, question, marks || 0);
    }
    if (question.question_typeid === 16) {
      return getType16Content(i + 1, question, marks || 0);
    }
    return getCommonContent(i + 1, question, marks || 0);
  });
  return data.join(" ");
}
